<template>
  <div class="promo-box">
    <div class="title-box">Use your promo code</div>
    <div class="user-input-box">
      <div class="input-box">
        <input type="text" @keydown.enter="checkCode" v-model="code">
        <button @click="checkCode">
          <font-awesome-icon icon="search" />
        </button>
      </div>
    </div>
    <div class="response-box" v-if="result.length != 0">
      <PlanCard v-for="plan in result" :data="plan" :key="plan._id" @reload="onReload"/>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import alert from '@/lib/alert'
import PlanCard from './PlanCard'

export default {
  name: 'PromoCodesBox',
  data() {
    return {
      code: '',
      result: []
    }
  },
  components: {
    PlanCard
  },
  methods: {
    checkCode() {
      if(this.code.trim() != '') {
        axios({
          method: 'post',
          url: `${process.env.VUE_APP_SERVER_URL}checkPromoCode`,
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token'),
          },
          data: {
            code: this.code
          }
        }).then(result => {
          this.result = [];
          this.result.push(result.data.planData);
        }).catch(() => {
          this.result = [];
          alert.showWarning('Code Not Found');
        })
      } else {
        alert.showError('Empty Code Input');
      }
    },
    onReload() {
      this.$emit('reload');
    }
  }
}
</script>

<style lang="scss" scoped>
.promo-box {
  width: 100%;
  height: auto;
  margin-top: 1rem;
  margin-bottom: 4rem;
  display: flex;
  flex-direction: column;
  background-color: white;
  filter:drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.171));
  overflow: hidden;

  .title-box {
    width: 100%;
    height: 4rem;
    display: flex;
    align-items: center;
    padding-left: 1rem;
    font-size: 1.1rem;
    background-color: #11b6a5;
    color: white;
    font-weight: bold;
  }

  .user-input-box {
    width: 100%;
    height: 6rem;
    display: flex;
    justify-content: center;
    align-items: center;

    input {
      width: 15rem;
      height: 2.5rem;
      padding-left: 0.5rem;
      padding-right: 0.5rem;
      font-size: 1.2rem;
    }

    button {
      margin-left: 0.5rem;
      width: 2.5rem;
      height: 2.5rem;
      background-color: #11b6a5;
      color: white;
      border: none;
      outline: none;
      transition: 0.2s;
      font-size: 1rem;
      font-weight: bold;

      &:hover {
        cursor: pointer;
        background-color: #10a193;
      }
    }
  }
  .response-box {
    width: 100%;
    height: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 1rem;
    padding-bottom: 2rem;
  }
}
</style>